<template>
  <el-table
    :row-class-name="tableRowClassName"
    :data="deps"
    style="width: 100%"
    height="250px"
    :cell-style="depClass"
  >
    <el-table-column align="center" prop="name" label="分组"> </el-table-column>
    <el-table-column align="center" prop="userCount" label="员工数">
    </el-table-column>
    <el-table-column align="center" prop="groupLeder" label="负责人">
      <template slot-scope="scope">
        {{ scope.row.groupLeder.toString() }}
      </template>
    </el-table-column>
    <el-table-column align="center" prop="allocationWeight" label="权重比例">
      <template slot-scope="scope" >
        <!-- AllotModel_Button_AllocationWeightEdit: 除了ROLE.BACK_DIRECTOR -->
        <AllocationWeight editPermission="AllotModel_Button_AllocationWeightEdit" @callback="callback" :row="scope.row" :item="item" />
      </template>
    </el-table-column>
    <el-table-column prop="canNum" align="center" label="可分配数">
    </el-table-column>
    <el-table-column prop="settedNum" align="center" label="组内已设定分配数">
    </el-table-column>
  </el-table>
</template>

<script>
import AllocationWeight from "./AllocationWeight";
import { getBackEndDepList } from "./api";
import { getBasicInfo } from "@/modules/user";
import { ROLE } from "@/modules/entities";
export default {
  name: "DepSet",
  components: { AllocationWeight },
  props: {
    item: {
      type: Object,
    },
    dep: { type: String },
  },
  data() {
    return {
      deps: [],
    };
  },
  async beforeMount() {
    await this.getList();
  },
  methods: {
    async getList() {
      let { data } = await getBackEndDepList({
        branch: this.item.branch,
        dep_id: this.dep,
        queue_id: this.item.queue_id,
      });
      this.deps = data;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.canNum !== row.settedNum) {
        return "warning-row";
      } else {
        return "";
      }
    },
    depClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 && row.same) {
        return "background:#fff";
      }
    },
    async callback() {
      await this.getList();
      this.$emit("callback");
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: #ffabab;
}
</style>